import { observer } from "mobx-react-lite";
import { Form } from "antd";
import { SelectFromReference } from "src/components/SelectFromReference";
import {
  ZArticleNumberMeta,
  zArticleNumberMetaObjRef,
} from "src/types/ZArticleNumberInfo";
import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import { ArticleAttrMetaCtrlFC } from "./getAttrArticleMetaFC";
import { loadAllObjectAttsOptions } from "../../../MetaInfo/loadAllObjectAttsOptions";

export const AttrArticleMetaObjRef: ArticleAttrMetaCtrlFC = observer(
  ({ attr, value, onChange, disabled }) => {
    const refId = attr.referenceId;
    const parseValue = () => {
      try {
        return zArticleNumberMetaObjRef.parse(value).refAttributeId;
      } catch (error) {
        return undefined;
      }
    };
    return (
      <Form.Item label={attr.name}>
        <SelectFromReference
          value={parseValue()}
          loader={() => loadAllObjectAttsOptions(refId)}
          disabled={disabled}
          onChange={(v) => {
            onChange?.({
              attributeId: attr.id,
              valueTypeName: AttrTypeName.object,
              refAttributeId: v,
            } satisfies ZArticleNumberMeta);
          }}
        />
      </Form.Item>
    );
  },
);
